<!--
  Loading
  No History
  List of cards
 -->
<template>
  <div>
    <div v-if="!ready">
      <blank></blank>
    </div>
    <!-- <div v-else-if="ready && !loading && cards.length == 0" class="text-center">
      <b-card>
        <h1>No Cards</h1>
        <p>Either you don't have any cards yet or they are failing to load</p>
        <b-button to="/deposit">New Card</b-button>
      </b-card>
    </div> -->
    <div v-else>
      <h1>My Cards</h1>
      <br />
      <div v-for="(c, index) in cards" :key="index">
        <div v-if="index == 0 || index % 3 == 0">
          <b-row>
            <b-col><card v-if="cards[index] != null" :tokenId="cards[index]"></card></b-col>
            <b-col><card v-if="cards[index + 1] != null" :tokenId="cards[index+1]"></card></b-col>
            <b-col><card v-if="cards[index + 2] != null" :tokenId="cards[index+2]"></card></b-col>
          </b-row>
          <br>
        </div>
      </div>
      <br />
      <!-- <div class="w-100 text-right">
        <b-button variant="primary" v-b-modal.modal-1>Sell Card</b-button>
      </div>
      <b-modal id="modal-1" title="BootstrapVue">
          <sell-form></sell-form>
      </b-modal>
      <br />
      <div v-for="card in cards" :key="card.id">
        <b-card>
          <template #header>
            <b-table-simple class="m-0" :items="card.basic" borderless small>
              <b-tr>
                <b-th colspan="2"><small class="text-muted">ID</small></b-th>
                <b-th colspan="2"
                  ><small class="text-muted">Submitted</small></b-th
                >
                <b-th colspan="2" class="text-right"
                  ><small class="text-muted">Penalty</small></b-th
                >
              </b-tr>
              <b-tr>
                <b-th colspan="2">{{ card.basic.id }}</b-th>
                <b-th colspan="2">{{ card.basic.submitted }}</b-th>
                <b-th colspan="2" class="text-right">
                  <b-badge
                    :variant="!card.basic.penalty ? 'success' : 'danger'"
                    >{{ card.basic.penalty }}</b-badge
                  >
                </b-th>
              </b-tr>
            </b-table-simple>
          </template>
          <b-row>
            <b-col cols="3"></b-col>
            <b-col cols="6">
              <h2>{{ card.details["type"] }}</h2>
              <h5 class="text-muted d-inline">Confirmed Balance:</h5>
              <span>{{ card.details["balance"] }} USD</span><br />
              <h5 class="text-muted d-inline">Collateral:</h5>
              <span>{{ card.details["collateral"] }} ETH</span><br />
              <h5 class="text-muted d-inline">Profit:</h5>
              <span>{{ card.details["profit"] }} CXC</span><br />
            </b-col>
            <b-col cols="3" class="text-right">
              <b-button :disabled="card.basic['sold'] ? true : false"
                >Cancel</b-button
              >
            </b-col>
          </b-row>
          <template #footer>
            <small class="text-muted mr-2">Sold: </small
            ><span>{{ card.basic["sold"] ? card.basic.sold : "N/A" }}</span>
          </template>
        </b-card>
        <br />
      </div> -->
    </div>
  </div>
</template>
<script>
import Blank from "@/components/Blank.vue";
import SellForm from "@/components/marketplace/sell/form.vue";
import Card from "@/components/dashboard/card.vue";
export default {
  components: { Blank, SellForm, Card },
  data() {
    return {
      loading: true,
      cards: [],
    };
  },
  computed: {
    ready() {
      return this.$store.state.ethereum.ready;
    },
  },
  methods: {
    getDocuments() {
      this.$store
        .dispatch("ethereum/getTokens")
        .then((tokens) => {
          this.cards = tokens;
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    ready: function (fresh, stale) {
      if (fresh == true) {
        this.getDocuments();
      }
    },
  },
  mounted() {
    if (this.ready) {
      this.getDocuments();
    }
  },
};
</script>
